import React, { useRef, useState } from 'react';
import {
    Grid, ArgumentAxis, Chart, Series, CommonSeriesSettings, Legend,
    ValueAxis, Export, Tooltip, Title, Subtitle, Margin
} from 'devextreme-react/chart';
import useApi from '../../hooks/useApi';
import uri from '../../utils/uri';
import { Button, DataGrid, SelectBox } from 'devextreme-react';
import useLocalStorage from '../../hooks/useLocalStorage';
import { formatToMoneyNumber } from '../../utils/common';
import {
    Column,
    Export as ExportGrid,   
}
    from 'devextreme-react/data-grid';
const TopBestClients2 = () => {

    const { itemState, setItem } = useLocalStorage();
    let dataGrid = useRef();
    const [open, setOpen] = useState(false);
    const [ topClients ] = useState([ 5, 10, 15, 20 ]);
    const [ topClientSelected, setTopClientSelected ] = useState(itemState.top || topClients[0]);

    const [ months ] = useState([ 
        { value: 1, text: 'Último Mes' },
        { value: 3, text: 'Últimos 3 Meses' },
        { value: 6, text: 'Últimos 6 Meses' },
        { value: 12, text: 'Últimos 12 Meses' }
    ]);
    const [ monthSelected, setMonthSelected ] = useState(itemState.lastMonth || months[0].value);

    const { data } = useApi({ url: uri.dashboard.base + '/get-clients-top?lastMonth=' + monthSelected + '&top=' + topClientSelected });  

    function contentRender(arg) {

        const { clientName, ventaContado, ventaCredito } = arg.point.data;
        const total = ventaContado + ventaCredito;

        return <div>
            <div>{clientName}</div>
            <div>Contado: {formatToMoneyNumber(ventaContado)}</div>
            <div>Credito: {formatToMoneyNumber(ventaCredito)}</div>
            <div>Total: <b>{formatToMoneyNumber(total)}</b></div>
        </div>
        // return {
        //     text: `${arg.seriesName} years: ${arg.valueText}`,
        // };
    }

    const setTopClient = (value) => {
        setTopClientSelected(value);
        setItem({ ...itemState, top: value });
    }

    const setMonth = (value) => {
        setMonthSelected(value);
        setItem({ ...itemState, lastMonth: value });
    }

    // [
    //     {
    //     "clientId": 32,
    //     "clientName": "VP001- CENTRO DE PINTURAS IRMA LOPEZ  .",
    //     "ventaContado": 0.0000,
    //     "ventaCredito": 29944.8200
    //     },
    // ]

    const exportData = () => {
        // Implement your export logic here

        dataGrid.current.instance.exportToExcel(false);
    }

    return (
        <div>
            <DataGrid
                visible={false}
                ref={dataGrid}
                id="grid"
                dataSource={data}
                showBorders={true}
            >
                <ExportGrid enabled={true} fileName={`Top ${topClientSelected} Mejores Clientes`}/>
                <Column dataField="clientName" caption="Cliente" />
                <Column dataField="ventaContado" caption="Venta Contado" />
                <Column dataField="ventaCredito" caption="Venta Credito" />
            </DataGrid>
            <Chart
                id="chart"
                title="Top Mejores Clientes"
                dataSource={data}
            >
                <CommonSeriesSettings
                    argumentField="clientName"
                    type="stackedbar"
                    barWidth={50}
                    showInLegend={true}
                />
                <Series
                    valueField="ventaContado"
                    name="Venta Contado"
                />
                <Series
                    valueField="ventaCredito"
                    name="Venta Credito"
                />
                <ValueAxis position="right">
                    <Title text="Ventas" />
                </ValueAxis>
                <Legend
                    verticalAlignment="top"
                    horizontalAlignment="center"
                    itemTextPosition="top"
                />
                <Export enabled={true} />
                <Tooltip
                    enabled={true}
                    location="edge"
                    contentRender={contentRender}

                />
            </Chart>
            <div className="options">                
                <div className="common">
                    <div className="d-flex">                      
                        <div className="option">
                            <span>Top clientes:</span>
                            <SelectBox
                                dataSource={topClients}
                                defaultValue={topClients[0]}
                                value={topClientSelected}
                                onValueChanged={(e) => setTopClient(e.value)}
                            />
                        </div>
                        <div className="option">
                            <span>Rango:</span>
                            <SelectBox
                                dataSource={months}
                                defaultValue={monthSelected}
                                value={monthSelected}
                                valueExpr="value"
                                displayExpr="text"
                                onValueChanged={(e) => setMonth(e.value)}
                            />
                        </div>  
                         <div className="option pt-24">
                            <Button onClick={exportData} text='Exportar' icon='xlsfile'/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TopBestClients2;
